/* eslint-disable max-len */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

import createReducer from '../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  discountCode: '',
  discountCodeStatus: {
    Success: null,
    Messages: '',
  },
  activeDiscountCode: {},
};

const getPaidReducer = createReducer(initialState, {
  [types.GETPAID_RESET_STATE]() {
    return {
      ...initialState
    };
  },
  [types.SET_DISCOUNT_CODE](state, action) {
    return {
      ...state,
      [action.field]: action.value,
      discountCodeStatus: initialState.discountCodeStatus,
    };
  },
  [types.VALIDATE_DISCOUNT_CODE](state) {
    return {
      ...state,
    };
  },
  [types.VALIDATE_DISCOUNT_CODE_STATUS](state, action) {
    return {
      ...state,
      discountCodeStatus: action.payload,
    };
  },
  [types.RESET_DISCOUNT_CODE](state) {
    return {
      ...state,
      discountCode: initialState.discountCode,
    };
  },
  [types.ACTIVE_DISCOUNT_CODE](state, action) {
    return {
      ...state,
      activeDiscountCode: action.payload
    };
  },
  [types.RESET_ACTIVE_DISCOUNT_CODE](state) {
    return {
      ...state,
      activeDiscountCode: initialState.activeDiscountCode,
      discountCode: initialState.discountCode,
      discountCodeStatus: initialState.customerFormStatus,
    };
  }
});

export default getPaidReducer;
